import _ from 'lodash';
import log from '$$log';
import globalStore from '$$globalStore';
import tasksHelpers from '$$store/tasks/helpers';
import CalendarWorker from '../../../components/workers/CalendarWorker';
import constants from '$$helpers/constants';

export default function (instance, ganttData) {
  instance.ganttDataApi.getAllProjectTasksData = () => {
    if (!ganttData) {
      return globalStore.getters['tasksModel/getAllData'];
    }

    return [ganttData.projectTasksData];
  };

  instance.ganttDataApi.getProjectTasksData = projectId => {
    if (!ganttData) {
      return globalStore.getters['tasksModel/getItem'](projectId);
    }

    return ganttData.projectTasksData;
  };

  instance.ganttDataApi.getTasksForGantt = projectId => {
    const projectTasksData = instance.ganttDataApi.getProjectTasksData(projectId);

    if (!projectTasksData) {
      return {
        data: [],
        links: [],
      };
    }

    const t = log.time('ganttData.prepareTasksForGantt');
    const tasksData = {
      data: projectTasksData.tasks ? projectTasksData.tasks.map(o => ({ ...o })) : [],
      links: projectTasksData.links ? projectTasksData.links.map(o => ({ ...o })) : [],
    };

    tasksData.data = _.orderBy(tasksData.data, ['parent', 'sortorder', 'id'], ['asc', 'asc', 'asc']);

    tasksData.data = tasksData.data.map(task => {
      if (task.parent === 1) {
        task.parent = 0;
      }
      task.needMultiviewBackground = false;
      task.calendar_id = task.gantt_id;

      if (task.parent === 0) {
        task.open = 1;
      }

      return task;
    }); // needs after correct dates in multiview
    t.end();

    return tasksData;
  };

  instance.ganttDataApi.getDefaultCustomValues = projectId => {
    const projectTasksData = instance.ganttDataApi.getProjectTasksData(projectId);

    return {
      status: projectTasksData.defaultCustomValues.status,
      priority: projectTasksData.defaultCustomValues.priority,
    };
  };

  instance.ganttDataApi.getLinkByGanttId = (projectId, linkId) => {
    const projectTasksData = instance.ganttDataApi.getProjectTasksData(projectId);

    if (!projectTasksData) {
      return {};
    }

    return projectTasksData.links.find(l => +l.id === +linkId) || {};
  };

  instance.ganttDataApi.getTasksDataForBreadcrumbs = (taskId, projectId) => {
    const projectData = instance.ganttDataApi.getProjectTasksData(projectId);
    const preparedTasksMap = _.keyBy(projectData?.tasks, 'id');

    const task = preparedTasksMap[taskId];
    const result = [];

    if (!task) {
      return;
    }

    let parent = task.parent;

    while (parent) {
      const parentData = preparedTasksMap[parent];

      parent = parentData && parentData.parent;
      (parent && parent !== 1) && result.push(parentData);
    }

    return result.reverse();
  };

  instance.ganttDataApi.generateUID = () => tasksHelpers.uid();

  instance.ganttDataApi.correctDatesByProjectCalendar = async ganttId => {
    const calculatedWorkerData = await CalendarWorker.calculate(ganttId, 'getTasksChangesAfterChangeProjectCalendar');

    if (calculatedWorkerData && calculatedWorkerData.tasks.length) {
      await globalStore.dispatch('tasksModel/updateTasks', {
        tasks: calculatedWorkerData.tasks,
        sourceEvent: {
          type: constants.GANTT_SOURCE_EVENT_TYPES.PROJECT_CALENDAR_UPDATE,
        },
        fromGantt: false, // need for update gantt chart
      });
    }
  };
}
